import { getRandomNviroColors, transparentize } from 'src/utils/util';


const buildSpeciesIndicator = ({ indicatorsData, prefix }) =>
  ({
    occurrences: indicatorsData[`${prefix}Occurrences`],
    species: indicatorsData[`${prefix}Species`],
    eecc: indicatorsData[`${prefix}EeccSpecies`],
    natives: indicatorsData[`${prefix}NativeSpecies`],
    endemic: indicatorsData[`${prefix}EndemicSpecies`],
    exotic: indicatorsData[`${prefix}ExoticSpecies`],
    years: indicatorsData.years,
    originData: indicatorsData,
  });

const speciesColors = getRandomNviroColors(5);
const buildSpeciesChart = ({ chartData, prefix }) => {
  const colors = speciesColors;
  const filterKeys = [ 'Occurrences', 'Species', 'EeccSpecies', 'NativeSpecies', 'EndemicSpecies', 'ExoticSpecies' ]
    .map(f => `${prefix}${f}`);
  const chart = {
    labels: chartData.years,
    datasets: Object.keys(chartData).filter(key => filterKeys.includes(key)).map((key, idx) => (
      {
        data: chartData[key].data,
        label: chartData[key].label,
        backgroundColor: transparentize(colors[idx % 5]),
        borderColor: colors[idx % 5],
        tension: 0.1,
      }
    )),
    originData: chartData,
  };
  return chart;
};


export {
  buildSpeciesIndicator,
  buildSpeciesChart,
};